import React from 'react';

import { CamerasTable } from '../components/index.js';

const Cameras = () => {
  return <CamerasTable />;
};

export default Cameras;
